import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

// This provides the $http property for Vue classes
Vue.use(VueAxios, axios);
